import { BriefPricingAggregate } from "@features/BriefPricingAggregate";
import ShareCampaignModal from "@features/ShareCampaignModalV2";
import {
  IBriefInfluencerSearchRequestV2,
  IBriefInfluencerV2,
} from "@shared/lib/types/briefInfluencerV2";
import { Button, Drawer, Input } from "@shared/ui";
import BriefInfDropDown from "@widgets/BriefInfDropDown";
import { Calculator, ChevronRight, Plus, Search, Share } from "lucide-react";
import { useState } from "react";
import { CampaignBriefStage } from "../lib/campaignBriefStage";
import styles from "./CampaignBriefFilters.module.scss";
import { CampaignBriefStageTabs } from "./CampaignBriefStageTabs";

export type StatusFilter = CampaignBriefStage;

interface CampaignBriefFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  activeStatusFilter: StatusFilter;
  onStatusFilterChange: (filter: StatusFilter) => void;
  reviewingCount: number;
  shortlistedCount: number;
  purchasedCount: number;
  searchParams: Partial<IBriefInfluencerSearchRequestV2>;
  selectedRows?: IBriefInfluencerV2[];
  onAddCreator: () => void;
}

export function CampaignBriefFilters({
  searchQuery,
  onSearchChange,
  activeStatusFilter,
  onStatusFilterChange,
  reviewingCount,
  shortlistedCount,
  purchasedCount,
  searchParams,
  selectedRows,
  onAddCreator,
}: CampaignBriefFiltersProps) {
  const [openShareDrawer, setOpenShareDrawer] = useState<boolean>(false);
  const [pricingAggregaeModalVisible, setPricingAggregaeModalVisible] =
    useState<boolean>(false);

  return (
    <div className={styles.filtersRoot}>
      <CampaignBriefStageTabs
        activeStage={activeStatusFilter}
        onStageChange={onStatusFilterChange}
        reviewingCount={reviewingCount}
        shortlistedCount={shortlistedCount}
        purchasedCount={purchasedCount}
      />

      <div className={styles.filtersGrid}>
        <div className={styles.searchContainer}>
          <Input
            size="small"
            placeholder="Search name, handle, or package..."
            value={searchQuery}
            onChange={(e) => {
              onSearchChange(e.target.value);
            }}
            prefix={<Search size={16} className={styles.searchIcon} />}
            className={styles.searchInput}
          />
        </div>

        <div className={styles.actionsContainer}>
          {activeStatusFilter === CampaignBriefStage.Reviewing && (
            <Button
              type="primary"
              className={styles.addCreatorButton}
              icon={<Plus size={14} />}
              onClick={onAddCreator}
            >
              Add creator
            </Button>
          )}
          <button
            className={styles.filterButton}
            onClick={() => setOpenShareDrawer(true)}
          >
            <Share size={14} />
            Share
          </button>

          {/* <BriefNotificationsDropDown triggerClassName={styles.filterButton} /> */}
          <BriefInfDropDown
            triggerClassName={styles.filterButton}
            searchParams={searchParams}
            selectedRows={selectedRows}
          />
          <Button
            className={styles.pricingStatusButton}
            icon={<Calculator size={14} />}
            onClick={() => setPricingAggregaeModalVisible(true)}
          >
            Pricing status
            <ChevronRight size={12} className={styles.pricingStatusChevron} />
          </Button>
        </div>
      </div>

      <ShareCampaignModal
        isOpen={openShareDrawer}
        onClose={() => setOpenShareDrawer(false)}
        cards={["planning", "pricing"]}
      />
      <Drawer
        title="Pricing Aggregate"
        open={pricingAggregaeModalVisible}
        onClose={() => setPricingAggregaeModalVisible(false)}
        footer={null}
        width={800}
        destroyOnClose
      >
        <BriefPricingAggregate
          open={pricingAggregaeModalVisible}
          onClose={() => setPricingAggregaeModalVisible(false)}
        />
      </Drawer>
    </div>
  );
}
